"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames2 = _interopRequireDefault(require("classnames"));

var _View = _interopRequireDefault(require("@instructure/ui-layout/lib/components/View"));

var _uiThemeable = _interopRequireDefault(require("@instructure/ui-themeable"));

var _ThemeablePropTypes = _interopRequireDefault(require("@instructure/ui-themeable/lib/utils/ThemeablePropTypes"));

var _passthroughProps = require("@instructure/ui-utils/lib/react/passthroughProps");

var _theme = _interopRequireDefault(require("./theme"));

var _dec, _class, _class2, _temp;

var styles = {
  componentId: 'bAGdE',
  template: function template(theme) {
    return "\n\n.bAGdE_bGBk,.bAGdE_bGBk[type=button],.bAGdE_bGBk[type=reset],.bAGdE_bGBk[type=submit]{-moz-appearance:none;-webkit-appearance:none;appearance:none}\n\n.bAGdE_bGBk{-moz-user-select:none;-ms-user-select:none;-webkit-user-select:none;background:transparent;border:none;box-sizing:border-box;direction:inherit;font-family:".concat(theme.fontFamily || 'inherit', ";margin:0;max-width:100%;outline:none;overflow:visible;position:relative;text-align:inherit;text-decoration:none;touch-action:manipulation;user-select:none}\n\n[dir=ltr] .bAGdE_bGBk,[dir=rtl] .bAGdE_bGBk{text-align:inherit}\n\n.bAGdE_bGBk.bAGdE_cKJj:before,.bAGdE_bGBk.bAGdE_cMUw:before{border-style:solid;border-width:").concat(theme.borderWidth || 'inherit', ";bottom:-0.25rem;content:\"\";left:-0.25rem;opacity:0;pointer-events:none;position:absolute;right:-0.25rem;top:-0.25rem;transform:scale(0.01);transition:all 0.2s}\n\n.bAGdE_bGBk.bAGdE_bXiG:before{border-color:").concat(theme.borderColorPrimary || 'inherit', "}\n\n.bAGdE_bGBk.bAGdE_ddvR:before{border-color:").concat(theme.borderColorError || 'inherit', "}\n\n.bAGdE_bGBk.bAGdE_enfx:before{border-color:").concat(theme.borderColorInverse || 'inherit', "}\n\n.bAGdE_bGBk.bAGdE_cMUw:before{border-radius:calc(").concat(theme.borderRadiusRectangular || 'inherit', " + 0.125rem)}\n\n.bAGdE_bGBk.bAGdE_cKJj:before{border-radius:").concat(theme.borderRadiusCircular || 'inherit', "}\n\n.bAGdE_bGBk.bAGdE_cVYB:before,.bAGdE_bGBk:focus:before{opacity:1;transform:scale(1)}");
  },
  'root': 'bAGdE_bGBk',
  'circular': 'bAGdE_cKJj',
  'rectangular': 'bAGdE_cMUw',
  'primary': 'bAGdE_bXiG',
  'error': 'bAGdE_ddvR',
  'inverse': 'bAGdE_enfx',
  'focused': 'bAGdE_cVYB'
};
var FocusableView = (
/**
---
parent: Focusable
---
**/
_dec = (0, _uiThemeable.default)(_theme.default, styles), _dec(_class = (_temp = _class2 =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(FocusableView, _Component);

  function FocusableView() {
    (0, _classCallCheck2.default)(this, FocusableView);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(FocusableView).apply(this, arguments));
  }

  (0, _createClass2.default)(FocusableView, [{
    key: "render",
    value: function render() {
      var _classnames;

      var _this$props = this.props,
          as = _this$props.as,
          children = _this$props.children,
          color = _this$props.color,
          cursor = _this$props.cursor,
          display = _this$props.display,
          elementRef = _this$props.elementRef,
          focused = _this$props.focused,
          href = _this$props.href,
          margin = _this$props.margin,
          onClick = _this$props.onClick,
          role = _this$props.role,
          shape = _this$props.shape,
          className = _this$props.className,
          to = _this$props.to,
          width = _this$props.width,
          tabIndex = _this$props.tabIndex,
          props = (0, _objectWithoutProperties2.default)(_this$props, ["as", "children", "color", "cursor", "display", "elementRef", "focused", "href", "margin", "onClick", "role", "shape", "className", "to", "width", "tabIndex"]);

      var passthroughProps = _View.default.omitViewProps((0, _passthroughProps.omitProps)(props, FocusableView.propTypes), FocusableView);

      return _react.default.createElement(_View.default, Object.assign({}, passthroughProps, {
        display: display,
        as: as,
        cursor: cursor,
        href: href,
        to: to,
        margin: margin,
        width: width,
        elementRef: elementRef,
        className: (0, _classnames2.default)((_classnames = {}, (0, _defineProperty2.default)(_classnames, className, className), (0, _defineProperty2.default)(_classnames, styles.root, true), (0, _defineProperty2.default)(_classnames, styles[color], true), (0, _defineProperty2.default)(_classnames, styles[shape], true), (0, _defineProperty2.default)(_classnames, styles.focused, focused), _classnames)),
        role: role || onClick ? role : null,
        tabIndex: onClick && !role ? tabIndex || '0' : tabIndex,
        onClick: onClick
      }), children);
    }
  }]);
  FocusableView.displayName = "FocusableView";
  return FocusableView;
}(_react.Component), _class2.propTypes = {
  children: _propTypes.default.node,

  /**
  * boolean value indicating focus. When true, the focus ring is visible
  */
  focused: _propTypes.default.bool,

  /**
  * Shape of the focus ring
  */
  shape: _propTypes.default.oneOf(["circular", "rectangular"]),

  /**
  * Color of the focus ring
  */
  color: _propTypes.default.oneOf(['primary', 'error', 'inverse']),

  /**
  * provides a reference to the underlying element
  */
  elementRef: _propTypes.default.func,

  /**
  * the element type to render as (will be `<a>` if href is provided)
  */
  as: _propTypes.default.elementType,

  /**
  * If `href` is provided, the `<FocusableView />` will render as a link
  */
  href: _propTypes.default.string,

  /**
  * By default the display prop is 'auto', meaning it takes on the
  * display rules of the html element it's rendered as (see `as` prop).
  */
  display: _propTypes.default.oneOf(['auto', 'block', 'inline-block', 'flex', 'inline-flex']),

  /**
  * Set the margin using familiar CSS shorthand
  */
  margin: _ThemeablePropTypes.default.spacing,

  /**
   * Specify a mouse cursor to use when hovering over the `<View />`
   */
  cursor: _propTypes.default.string,

  /**
   * Optionally set a width for the FocusableView (either a string or number)
   */
  width: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  role: _propTypes.default.string,
  onClick: _propTypes.default.func,
  tabIndex: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])
}, _class2.defaultProps = {
  children: null,
  href: void 0,
  width: void 0,
  margin: void 0,
  onClick: void 0,
  focused: false,
  shape: "rectangular",
  color: 'primary',
  display: 'inline-block',
  as: 'button',
  elementRef: function elementRef(element) {},
  cursor: 'auto',
  role: null,
  tabIndex: null
}, _temp)) || _class);
exports.default = FocusableView;